import type { MouseEventHandler, ReactNode } from 'react';

export interface TagData {
  children: ReactNode;
  color?: string;
  backgroundColor?: string;
  onClick?: MouseEventHandler;
}

export interface TagProps extends TagData {}
